(() => {
  const STORAGE_KEY = 'vc_age_verified_until_24h';
  const COOKIE_KEY = 'vc_age_verified_24h';
  const LEGACY_STORAGE_KEY = 'vc_age_verified_until';
  const LEGACY_COOKIE_KEY = 'vc_age_verified';
  const VERIFY_MS = 24 * 60 * 60 * 1000;
  const COOKIE_MAX_AGE = 24 * 60 * 60;

  const qs = new URLSearchParams(location.search);
  const forcePreview = qs.get('vc_age_gate') === 'preview';
  const forceReset = qs.get('vc_age_gate') === 'reset';

  const inDesignMode = !!(window.Shopify && Shopify.designMode);

  const readLocal = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const expires = Number(raw || 0);
      return Number.isFinite(expires) && expires > Date.now();
    } catch (_) {
      return false;
    }
  };

  const readCookie = () => document.cookie
    .split('; ')
    .some((item) => item === `${COOKIE_KEY}=1` || item.startsWith(`${COOKIE_KEY}=1;`));

  const clearVerified = () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch (_) {}
    document.cookie = `${COOKIE_KEY}=; Max-Age=0; Path=/; SameSite=Lax`;
    document.cookie = `${LEGACY_COOKIE_KEY}=; Max-Age=0; Path=/; SameSite=Lax`;
  };

  const clearLegacyVerified = () => {
    try { localStorage.removeItem(LEGACY_STORAGE_KEY); } catch (_) {}
    document.cookie = `${LEGACY_COOKIE_KEY}=; Max-Age=0; Path=/; SameSite=Lax`;
  };

  const saveVerified = () => {
    const expires = Date.now() + VERIFY_MS;
    try { localStorage.setItem(STORAGE_KEY, String(expires)); } catch (_) {}
    document.cookie = `${COOKIE_KEY}=1; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax`;
  };

  clearLegacyVerified();
  if (forceReset) clearVerified();

  const shouldSkip = !forcePreview && (readLocal() || readCookie());

  const init = () => {
    const gate = document.querySelector('[data-vc-age-gate]');
    if (!gate) return;

    // Keep Shopify Theme Editor usable. Use ?vc_age_gate=preview on a storefront preview URL to inspect the gate.
    if ((inDesignMode && !forcePreview) || shouldSkip) {
      gate.hidden = true;
      return;
    }

    const enter = gate.querySelector('[data-vc-age-enter]');
    const leave = gate.querySelector('[data-vc-age-leave]');

    gate.hidden = false;
    document.documentElement.classList.add('vc-age-gate-open');
    requestAnimationFrame(() => enter?.focus({ preventScroll: true }));

    const closeGate = () => {
      saveVerified();
      gate.hidden = true;
      document.documentElement.classList.remove('vc-age-gate-open');
    };

    enter?.addEventListener('click', closeGate);

    leave?.addEventListener('click', () => {
      gate.classList.add('is-denied');
      const fallback = 'https://www.google.co.uk/';
      setTimeout(() => {
        if (history.length > 1) history.back();
        else location.replace(fallback);
      }, 500);
    });

    // Keep focus within the modal while it is active.
    gate.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = [...gate.querySelectorAll('button:not([disabled])')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
